module.exports = __webpack_public_path__ + "static/assets/960146933f27531dfaacee7111f6a368.svg";